import { render } from "./material.vue?vue&type=template&id=3edbbc66"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"

import "./material.vue?vue&type=style&index=0&id=3edbbc66&lang=css"
script.render = render

export default script